import '../music.css';
import { Layout, Select, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space, Button ,notification,AutoComplete } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CalendarOutlined,EditOutlined,UserOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined,BarChartOutlined } from '@ant-design/icons';
import axios from "axios";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import {getAuthors,getAuthorsStr, getCountryName,getCountryCode,IP,downloadFile  } from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"

class Playslist extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;

    this.state={
      plays:[],
      showArticle:false,
      record:null,
      edit:false,
      conc:[],
      filteredInfo:[],
      reportCountry:null,
      makeCountryReport:false,
      isBusy:true
    }
  }
  async componentDidMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/composicion/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    this.countries = new Set();
    
    const Moment = require('moment');
    
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.codes.add(item.code);
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo=='undefined'? '':item.pseudonimo)
      this.countries.add(getCountryName(item.conc[0].pais))
      const year = date.split('-')[2]
      data.push(
          { 
              id : item.id,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo=='undefined'? '':item.pseudonimo,
              code:year+'_'+item.id,
              conc:item.conc,
              pdf:item.pdf,
              edit:''
          });
    };
   
    //Conc
    const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc})) 
    var data_conc = []
    this.names = new Set();
    this.emails = new Set();
    
    for(var i in json_conc){
      var item = json_conc[i];
      
      this.names.add(item.nombre_completo)
      this.emails.add(item.email)
      
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: item.pais,
              countryName: getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
          });
    };
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
   
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({ plays: data , conc:data_conc, filteredInfo:data,isBusy:false});
  }

  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };
 
  hideModal = () => {
    this.setState({showArticle: false, record: null });
  };

  hideEdit = () => {
    this.setState({edit: false,record: null});
  };

  onClickEditPlay(record){
        this.setState({edit:true,record:record});
  };
 
  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "category"){
      return this.categories
    }
    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }

async onClickSave(){
  var options = {
     method: "patch",
     credentials: "same-origin",
     headers: {
       "Authorization": localStorage.getItem("Authorization") ,
       "Accept": "application/json",
       "Content-Type": "application/json"},
     proxy: {
       host: 'localhost:8000',
       port: 8000
     }
   }
  
   var playChanged={}
     playChanged={
       titulo: document.getElementById("inputTitle").value,
       pseudonimo: document.getElementById("inputPseudo").value
     }

   await axios.patch(IP + `api/composicion/obra/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       if(response.status === 200)
          window.location.reload()
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
     },
     (error) => {
       console.log(error);
     }
   ).catch((err) => console.log(err))
 }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input className='music-input'
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || (<a onClick = {()=>this.onClickArticle(record)} >  {text}</a> )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({ searchText: selectedKeys[0],searchedColumn: dataIndex});
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };

  render() {
    const { SubMenu } = Menu;
    const { Option } = Select;
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays,"read")

    const downloadCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"read")

    const downloadConcReport =()=> generatePDFConc(this.state.conc,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

    const onClickCountryReport=()=>{
      this.setState({makeCountryReport:true})
    }
    const onClosekCountryReport=()=>{
      this.setState({makeCountryReport:false})
    }
    const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
      const {  Content } = Layout;
      const Moment = require('moment');
      const columns = [
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
              dataIndex: 'code',
              key: 'code',
              width:'8%',
              ...this.getColumnSearchProps('code','número'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
              dataIndex: 'title',
              key: 'title',
              sorter: (a, b) => a.title.localeCompare(b.title),
              ...this.getColumnSearchProps('title','título'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
              dataIndex: 'pseudo',
              key: 'pseudo',
              ...this.getColumnSearchProps('pseudo','seudónimo'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
              dataIndex: 'author',
              key: 'author',
              ...this.getColumnSearchProps('author','autor'),
              responsive: ['sm'] 
            },
            
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
              dataIndex: 'date',
              key: 'date',
              width:'8%',
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('date','fecha'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
              dataIndex: 'edit',
              key: 'edit',
              width:'5%',
              render: (text,record) =>(
                <div  style={{fontSize:'large' }}>
                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                </div>
              ),
              sortDirections:['ascend', 'descend', 'ascend'],
              responsive: ['sm'] 
              
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large' }}>Obra</div>,
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('name','nombre'),
              render: (record) => (
                <React.Fragment>
                  <a onClick = {()=>this.onClickArticle(record)} >   
                  <b style={{fontSize:'large'}}>{record.title}</b>
                  </a>

                  <br />
                  <b>Código:</b>{record.code}
                  <br />
                  <b>Seudónimo:</b>{record.pseudo}
                  <br />
                  <b>Autor(es):</b><ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> 
                  <br />
                  <b>Fecha:</b>{record.date}
                </React.Fragment>
              ),
              responsive: ['xs'] 
            },
            {
              dataIndex: 'edit',
              key: 'edit',
              width:'15%',
              render: (text,record) =>(
                          <div  style={{fontSize:'large' }}>
                          <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                          </div>
              ),
              sortDirections:['ascend', 'descend', 'ascend'],
              responsive: ['xs'] 
            },
          ];
    const reportsMenu = (
      <SubMenu key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
        <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
                <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
            <Menu.Item>
                <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.Item>
            <h4 onClick={onClickCountryReport}  style={{  color:'black'}}>Por país específico</h4>
          </Menu.Item>
        </SubMenu>
        <SubMenu  key="conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
          <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
              <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
      </SubMenu>
    )
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <AdminMenu defaultSelectedKey={"plays"} reportMenu={reportsMenu} />
              <Content>
                <Row>
                  <Col span={24}>
                    <Table
                      bordered
                      columns={columns}
                      dataSource= {this.state.plays}
                      pagination={{ position: ["bottomCenter"],}} 
                      tableLayout='fixed'
                      size='small'
                      style={{ whiteSpace: 'normal'}}
                      onChange = {this.handleTableChange}
                    />
                  </Col>
                </Row>
                {this.state.showArticle && 
                  <Modal 
                    closable = {false}
                    title={ this.state.record.code}
                    visible={this.state.showArticle} 
                    onCancel={this.hideModal}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                          Regresar
                        </Button>,
                    ]}
                  >
                    {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}
                      <p><FileTextOutlined />Título: {this.state.record.title}</p>
                      <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                      <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                      <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>
                      <p>
                        <Button onClick={()=>downloadFile(this.state.record)} >
                          <FilePdfOutlined/>  Descargar Zip
                        </Button>
                      </p>
                    </Modal>
                    || (this.state.edit && 
                    <Modal 
                      closable = {false}
                      title={ this.state.record.code}
                      visible={this.state.edit} 
                      onCancel={this.hideEdit}
                      footer={[
                        <Button key="save" onClick={()=>this.onClickSave()}>
                          Guardar
                        </Button>,
                        <Button key="back" onClick={this.hideEdit}>
                          Regresar
                        </Button>,
                      ]}
                    >
                      {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}
                      <p><FileTextOutlined />Título: <Input className='music-input' style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" /></p>
                      <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                      <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                      <p><AuditOutlined />Seudónimo: <Input className='music-input' defaultValue={this.state.record.pseudo}style={{width:'70%'}} id="inputPseudo"/></p>
                      <p>
                        <Button onClick={()=>downloadFile(this.state.record)} >
                        <FilePdfOutlined/>  Descargar Zip
                          </Button>
                      </p>
                    </Modal>)
                  }
           
                  {this.state.makeCountryReport &&
                  <Modal
                    closable = {false}
                    title="Reporte por país"
                    visible={this.state.makeCountryReport}
                    footer={[
                      <Button key="back" onClick={onClosekCountryReport}>
                       Regresar
                      </Button>,
                    ]}
                  >
                    <Select
                    style={{width:'80%'}}
                    defaultValue={this.state.reportCountry}
                    onChange={onChangeReportCountry}
                    >
                      {[...this.countries].map(c => {return <Option value={c}>{c}</Option>})}
                    </Select>
                    <div>
                      <br/>
                      <Button onClick={readPlayReportSelectedCountry}>Ver</Button> <Button onClick={downloadPlayReportSelectedCountry}>Descargar</Button>
                    </div>
                  </Modal>}
                </Content>
              </Layout>
            </ConfigProvider>
          </div>
        <Foot admin={true}/>
      </div>
    );
  }
}
export default Playslist;


